var _desc, _defs, _g, _path, _g2, _g3, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel5Bojin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "level-5-bojin-title"
  }, "CRM \u5E74\u5EA6\u4E1A\u7EE9\u6BB5\u4F4D\uFF1A\u94C2\u91D1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "level-5-bojin-title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "level-5-bojin-desc"
  }, "\u94C2\u91D1\u6BB5\u4F4D\u7684\u7EDF\u4E00\u7CFB\u5217\u7EB9\u7AE0\u5FBD\u7AE0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "level-5-bojin-metal",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9fff4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "48%",
    stopColor: "#2aa198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#126b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "level-5-bojin-shield",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9fff4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "34%",
    stopColor: "#2aa198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#126b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "level-5-bojin-accent",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9fff4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#6fe3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#126b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "level-5-bojin-gold",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff1a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#f2c14e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a86708"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "level-5-bojin-gem",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eff9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    stopColor: "#7db8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174da9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#level-5-bojin-metal)",
    stroke: "#0c494d",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 174C48 155 37 129 39 103c1-14 5-28 13-40",
    fill: "none",
    stroke: "url(#level-5-bojin-metal)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 174c24-19 35-45 33-71-1-14-5-28-13-40",
    fill: "none",
    stroke: "url(#level-5-bojin-metal)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58,
    cy: 151,
    rx: 7,
    ry: 14,
    transform: "rotate(-38 58 151)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48,
    cy: 133,
    rx: 7,
    ry: 14,
    transform: "rotate(-56 48 133)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44,
    cy: 113,
    rx: 7,
    ry: 14,
    transform: "rotate(-72 44 113)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47,
    cy: 91,
    rx: 7,
    ry: 14,
    transform: "rotate(-88 47 91)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 55,
    cy: 69,
    rx: 7,
    ry: 14,
    transform: "rotate(-130 55 69)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 182,
    cy: 151,
    rx: 7,
    ry: 14,
    transform: "rotate(38 182 151)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 192,
    cy: 133,
    rx: 7,
    ry: 14,
    transform: "rotate(56 192 133)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 196,
    cy: 113,
    rx: 7,
    ry: 14,
    transform: "rotate(72 196 113)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 193,
    cy: 91,
    rx: 7,
    ry: 14,
    transform: "rotate(88 193 91)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 185,
    cy: 69,
    rx: 7,
    ry: 14,
    transform: "rotate(130 185 69)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 66,
    cy: 86,
    rx: 7,
    ry: 13,
    transform: "rotate(-38 66 86)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63,
    cy: 108,
    rx: 7,
    ry: 13,
    transform: "rotate(-50 63 108)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 174,
    cy: 86,
    rx: 7,
    ry: 13,
    transform: "rotate(38 174 86)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 177,
    cy: 108,
    rx: 7,
    ry: 13,
    transform: "rotate(50 177 108)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 98,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183,
    cy: 98,
    r: 4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 15l6 12 14 2-10 10 2 14-12-7-12 7 2-14-10-10 14-2z",
    fill: "url(#level-5-bojin-accent)",
    stroke: "#0c494d",
    strokeWidth: 3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M120 43 L169 62 L162 137 C158 164 141 183 120 194 C99 183 82 164 78 137 L71 62 Z",
    transform: "translate(0 3)",
    fill: "#0c494d",
    opacity: 0.4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 43 L169 62 L162 137 C158 164 141 183 120 194 C99 183 82 164 78 137 L71 62 Z",
    fill: "url(#level-5-bojin-shield)",
    stroke: "#0c494d",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 51L160 67l-6 68c-3 21-15 38-34 49-19-11-31-28-34-49l-6-68z",
    fill: "none",
    stroke: "#b9fff4",
    strokeWidth: 2,
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 126,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: 48,
    fontWeight: 700,
    letterSpacing: 0,
    fill: "url(#level-5-bojin-accent)",
    stroke: "#0c494d",
    strokeWidth: 2,
    paintOrder: "stroke fill"
  }, "V"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#0c494d",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 179H81v28H47l8-14z",
    fill: "url(#level-5-bojin-metal)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 179h-36v28h34l-8-14z",
    fill: "url(#level-5-bojin-metal)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 174q47 13 94 0v31q-47 13-94 0z",
    fill: "url(#level-5-bojin-accent)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 184q39 9 78 0",
    fill: "none",
    stroke: "#b9fff4",
    strokeWidth: 2,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 174l8 10-8 18m94-28-8 10 8 18",
    fill: "#126b6b"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 199,
    textAnchor: "middle",
    fontFamily: "'Noto Sans SC','Microsoft YaHei',sans-serif",
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: 2,
    fill: "#0c494d"
  }, "\u94C2\u91D1")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel5Bojin);
export default __webpack_public_path__ + "static/media/level-5-bojin.1187446c6542f921ad5197d2c1739c3d.svg";
export { ForwardRef as ReactComponent };